// React router that changes between home, workbook and createbonsai
import { getAuth } from "firebase/auth";
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
// import { bonsai } from "../libs/fakeDesignData";
import { useNavigateToTop } from "../libs/useNavigateToTop";
import ScreenLogin from "./Login";
import ScreenCreateResourceList from "./CreateResourceList";
import { getData } from "../libs/firebase/firestore/getData";
import { getAllData } from "../libs/firebase/firestore/getAllData";
import ScreenCreateResourceLists from "./ResourceLists";
import ScreenResourceList from "./ResourceList";
import ScreenPlannerRoot from "./Planner/Root";
import ScreenPlannerTasks from "./Planner/Tasks";
import ScreenEditResourceList from "./EditResourceList";
import ScreenReportingRoot from "./Reporting/Root";
import ExplorerRoot from "./Explorer/Root";
import ExporerCreatePlant from "./Explorer/CreatePlant";
import ScreenDesignerCreateSite from "./Designer/CreateSite";
import ScreenDesignerSites from "./Designer/Sites";
import ScreenDesignerSite from "./Designer/Site";
import ScreenHome from "./Home";
import ScreenPlannerLastVisit from "./Planner/LastVisit";
import ScreenMyGarden from "./MyGarden/Root";
import Sites from "./Sites";
import Site from "./Site";
import SiteSetup from "./SiteSetup";
import ScreenShare from "./Share";
import Tasks from "./Tasks";
import ScreenGuide from "./Guide";
import ScreenCreateGuide from "./CreateGuitde";
import ScreenAccount from "./Account";
import ScreenFeedback from "./Feedback";
import { ScreenEditGuide } from "./EditGuide";
import ScreenSignUp from "./SignUp";
import ScreenReviewSystem from "./ReviewSystem";

let fakeData = [];

const rememberEditMade = () => {
  localStorage.setItem("bonsai-workbook_edited", true);
};

function ScreenRoot() {
  const [loading, setLoading] = React.useState(true);

  const navigate = useNavigateToTop();

  const handleLoginSuccess = () => {
    navigate("/");
  };

  const handleSignUpSuccess = () => {
    navigate("/");
  };

  let currentUser = getAuth().currentUser;

  if (!currentUser) {
    // navigate to login
    setTimeout(() => {
      currentUser = getAuth().currentUser;
      if (!currentUser) {
        // check if the route contains signup
        // if it does not contain signup then navigate to login
        // if it does contain signup then do nothing
        if (
          (window.location.href.indexOf("signup") === -1 &&
          window.location.href.indexOf("login") === -1 &&
          // just the root page "/" with nothing after
          window.location.href != window.location.origin + "/" &&
          
          window.location.href.indexOf("bonsai-guide") === -1) ||
          
        window.location.href.indexOf("create") != -1

        ) {
          navigate("/login");
        }
      } else {
        setLoading(false);
        // navigate("/");
      }
    }, 1000);
  }
  if (!currentUser && 
    (window.location.href.indexOf("signup") === -1 &&
    window.location.href.indexOf("login") === -1 &&
    // just the root page "/" with nothing after
    window.location.href != window.location.origin + "/"&&
          
    window.location.href.indexOf("bonsai-guide") === -1) ||
    
    !currentUser && window.location.href.indexOf("create") != -1) {
    return <ScreenLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <Routes>
      <Route path="/">
        <Route index element={<ScreenHome />} />
        <Route path="reviewSystem" element={<ScreenReviewSystem />} />
        <Route path="bonsai-guide/:guideId">
          <Route index element={<ScreenGuide />} />
          <Route path="edit">
            <Route index element={<ScreenEditGuide />} />
            </Route>
        </Route>
        <Route path="bonsai-guide/create">
          <Route index element={<ScreenCreateGuide />} />
        </Route>
        
        {/* Account */}
        <Route path="account">
          <Route index element={<ScreenAccount />} />
        </Route>
        {/* Feedback */}
        <Route path="feedback">
          <Route index element={<ScreenFeedback />} />
        </Route>
        {/* Share */}
        <Route path="share/:shareLinkId">
          <Route index element={<ScreenShare />} />
        </Route>
        <Route path="sites">
          <Route index element={<Sites />} />
        </Route>
        <Route path="mygarden">
          <Route index element={<ScreenMyGarden />} />
        </Route>
        <Route path="explorer">
          <Route index element={<ExplorerRoot />} />
          <Route path="createPlant">
            <Route index element={<ExporerCreatePlant />} />
          </Route>
        </Route>
        <Route path="designer">
          <Route index element={<ScreenDesignerSites />} />
          <Route path="site/:siteId">
            <Route index element={<ScreenDesignerSite />} />
          </Route>
          <Route path="createSite">
            <Route index element={<ScreenDesignerSite />} />
          </Route>
        </Route>
        <Route path="planner">
          <Route index element={<ScreenPlannerTasks />} />
          <Route path="lastVisit">
            <Route index element={<ScreenPlannerLastVisit />} />
          </Route>
        </Route>
        <Route path="reporting">
          <Route index element={<ScreenReportingRoot />} />
        </Route>
        <Route path="resourceLists">
          <Route index element={<ScreenCreateResourceLists />} />
        </Route>
        <Route path="resource-list">
          <Route path=":resourceListId" element={<ScreenEditResourceList />} />
        </Route>
        <Route path="create-resource-list">
          <Route index element={<ScreenCreateResourceList />} />
        </Route>
        <Route
          path="login"
          element={<ScreenLogin onLoginSuccess={handleLoginSuccess} />}
        />
        <Route
          path="signUp"
          element={<ScreenSignUp onSignUpSuccess={handleSignUpSuccess} />}
        />
        <Route path=":userId">
          {/* <Route
            index
            element={
              <ScreenDashboard onClick={handleOpenBonsaiProfileOtherUser} />
            }
          /> */}
        </Route>
        {/* <Route path="account" element={<ScreenAccount />}></Route> */}
      </Route>
    </Routes>
  );
}

export default ScreenRoot;
